import { render, staticRenderFns } from "./RptDevActTot.vue?vue&type=template&id=b2ff19f0"
import script from "./RptDevActTot.vue?vue&type=script&lang=js"
export * from "./RptDevActTot.vue?vue&type=script&lang=js"
import style0 from "./RptDevActTot.vue?vue&type=style&index=0&id=b2ff19f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports